import defaultPosition from "@/helpers/wc/positionSettings";

export const visitExpressSearchSettings = {
  title: "VisitExpress Search",
  name: "visitExpressSearchBase",

  styles: defaultPosition,

  properties: {
    text: [],
    confirmationDialog: [],
    personConfirm: [],
    includeCompanyName: false,
    includeLicensePlate: false,
    routeName: '',
    smsVisitor: false,
    css: {
      button: {
        fontFamily: "Arial",
        fontSize: 14,
        color: 'white',
        backgroundColor: 'limegreen',
        borderColor: 'grey',
        borderRadius: '5px'
      }
    }
  },
  cssLegend: {
    button: {
      name: "Button",
      fontFamily: {
        type: "fontFamily",
        name: "Font Family"
      },
      fontSize: {
        type: "int",
        name: "Font Size",
        handler: val => val + 'px'
      },
      color: {
        type: "color",
        name: "Color"
      },
      backgroundColor: {
        type: "color",
        name: "Background"
      },
      borderColor: {
        type: "color",
        name: "Border Color"
      },
      borderRadius: {
        type: "int",
        name: "Border Radius",
        handler: val => val + 'px'
      }
    }
  }
};
